__turbopack_context__.v({
  "ad-abuse": "AdAbuse-module-scss-module__t-H_jG__ad-abuse",
  "ad-button-label": "AdAbuse-module-scss-module__t-H_jG__ad-button-label",
  "desktop": "AdAbuse-module-scss-module__t-H_jG__desktop",
  "loader": "AdAbuse-module-scss-module__t-H_jG__loader",
  "mobile": "AdAbuse-module-scss-module__t-H_jG__mobile",
  "rotation": "AdAbuse-module-scss-module__t-H_jG__rotation",
});
